
import { useState } from 'react';

const ClubManagementSection = () => {
  const [activeTab, setActiveTab] = useState('branded-app');

  const tabs = [
    { id: 'branded-app', label: 'Branded App', icon: 'ri-smartphone-line' },
    { id: 'scheduling', label: 'Scheduling', icon: 'ri-calendar-line' },
    { id: 'store-management', label: 'Store Management', icon: 'ri-store-line' },
    { id: 'sponsorship', label: 'Maximize Sponsorship & Partnerships', icon: 'ri-handshake-line' },
    { id: 'team-management', label: 'Team Management', icon: 'ri-team-line' },
    { id: 'communication-channels', label: 'Communication Channels', icon: 'ri-message-3-line' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'branded-app':
        return (
          <div className="bg-white rounded-lg p-6">
            <div className="text-center mb-6">
              <h4 className="text-2xl font-bold text-gray-900 mb-2">Your Brand, Your Identity, Your Future</h4>
              <p className="text-gray-600">Elevate Your Brand with a Custom Mobile App, Available Everywhere</p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20sports%20team%20mobile%20app%20interface%20showing%20Houston%20Highguards%20dashboard%20with%20dark%20blue%20background%2C%20sponsor%20carousel%20at%20top%2C%20my%20dashboard%20section%20with%20club%20matches%20schedule%20stats%20executives%20payments%20and%20documents%20icons%2C%20navigation%20tabs%20at%20bottom%20for%20home%20social%20media%20shop%20and%20profile%2C%20modern%20sports%20app%20design&width=300&height=600&seq=houston-app-mockup&orientation=portrait"
                  alt="Houston Highguards Branded Mobile App"
                  className="w-full h-80 object-cover object-top rounded-lg shadow-lg"
                />
                <div className="absolute top-4 left-4 bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  Custom Brand
                </div>
              </div>
              <div className="space-y-4">
                <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-palette-line text-orange-600"></i>
                    </div>
                    <h5 className="font-semibold text-gray-900">Branded for Impact</h5>
                  </div>
                  <p className="text-sm text-gray-600">Customize your app with your team's colors, logo, and design to create a unique and memorable brand experience.</p>
                </div>
                
                <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-user-smile-line text-blue-600"></i>
                    </div>
                    <h5 className="font-semibold text-gray-900">Seamless User Experience</h5>
                  </div>
                  <p className="text-sm text-gray-600">Simplify communication for players, families, fans, and sponsors with a sleek, easy-to-navigate interface.</p>
                </div>
                
                <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-trophy-line text-purple-600"></i>
                    </div>
                    <h5 className="font-semibold text-gray-900">Legacy in the Making</h5>
                  </div>
                  <p className="text-sm text-gray-600">Build a lasting impression with an app that fosters community, enhances engagement, and strengthens long-term loyalty.</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-orange-50 to-blue-50 rounded-lg p-4">
              <div className="flex items-center justify-between">
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1">Ready to Launch Your Brand?</h5>
                  <p className="text-sm text-gray-600">Create a custom-branded app that reflects your team's unique identity</p>
                </div>
                <button className="bg-orange-500 text-white px-6 py-2 rounded-lg hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer">
                  Get Started
                </button>
              </div>
            </div>
          </div>
        );
      case 'video':
        return (
          <div className="relative bg-black rounded-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20baseball%20game%20live%20streaming%20interface%20with%20team%20scores%20overlay%2C%20modern%20sports%20broadcast%20view%20with%20player%20statistics%20and%20real-time%20game%20information%2C%20clean%20digital%20scoreboard%20display&width=600&height=400&seq=club-video&orientation=landscape"
              alt="Live Game Stream"
              className="w-full h-80 object-cover object-top"
            />
            <div className="absolute top-4 left-4 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
              <div className="w-2 h-2 bg-white rounded-full mr-2 animate-pulse"></div>
              LIVE
            </div>
            <div className="absolute top-4 right-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm">
              247 viewers
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
              <div className="flex justify-between items-center text-white mb-2">
                <div className="text-lg font-bold">Eagles 7 - 4 Hawks</div>
                <div className="text-sm">Bottom 7th</div>
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="text-sm">A.Sylla #22 | S.Lopez #4</div>
                </div>
                <div className="flex items-center space-x-2">
                  <button className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30">
                    <i className="ri-volume-up-line text-sm"></i>
                  </button>
                  <button className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30">
                    <i className="ri-settings-line text-sm"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      case 'scheduling':
        return (
          <div className="bg-white rounded-lg p-6">
            <div className="mb-4">
              <h4 className="text-lg font-semibold text-gray-900 mb-2">March 2024 Schedule</h4>
              <div className="mb-4">
                <img 
                  src="https://static.readdy.ai/image/339666f1cc2ed60abac278570d511bdf/6a6597899d804513c8db0a7fed04b698.png"
                  alt="Club Matches Calendar Interface"
                  className="w-full h-80 object-cover object-top rounded-lg shadow-lg"
                />
              </div>
              <div className="grid grid-cols-7 gap-1 text-center text-sm">
                <div className="font-semibold text-gray-600 p-2">Sun</div>
                <div className="font-semibold text-gray-600 p-2">Mon</div>
                <div className="font-semibold text-gray-600 p-2">Tue</div>
                <div className="font-semibold text-gray-600 p-2">Wed</div>
                <div className="font-semibold text-gray-600 p-2">Thu</div>
                <div className="font-semibold text-gray-600 p-2">Fri</div>
                <div className="font-semibold text-gray-600 p-2">Sat</div>
                {Array.from({ length: 31 }, (_, i) => (
                  <div key={i + 1} className={`p-2 rounded cursor-pointer hover:bg-gray-100 ${
                    [5, 12, 19, 26].includes(i + 1) ? 'bg-orange-100 text-orange-800 font-semibold' : 'text-gray-700'
                  }`}>
                    {i + 1}
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-4 space-y-2">
              <div className="flex items-center justify-between p-2 bg-orange-50 rounded">
                <span className="text-sm font-medium">Eagles vs Hawks</span>
                <span className="text-xs text-gray-600">Mar 5, 3:00 PM</span>
              </div>
              <div className="flex items-center justify-between p-2 bg-blue-50 rounded">
                <span className="text-sm font-medium">Practice Session</span>
                <span className="text-xs text-gray-600">Mar 12, 4:00 PM</span>
              </div>
            </div>
          </div>
        );
      case 'sponsorship':
        return (
          <div className="bg-white rounded-lg p-6">
            <div className="text-center mb-6">
              <h4 className="text-2xl font-bold text-gray-900 mb-2">Unlock Strategic Value and Sustainable Growth</h4>
              <p className="text-gray-600">Turn every sponsorship and partnership into a growth engine for your team. With CLUB7MS, managing sponsors and partners has never been easier.</p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20sports%20sponsorship%20partnership%20meeting%20with%20business%20executives%20shaking%20hands%2C%20corporate%20logos%20and%20brand%20partnerships%20display%2C%20modern%20conference%20room%20setting%2C%20strategic%20business%20collaboration%2C%20clean%20professional%20environment&width=400&height=300&seq=sponsorship-meeting&orientation=landscape"
                  alt="Sponsorship Partnership Management"
                  className="w-full h-64 object-cover object-top rounded-lg shadow-lg"
                />
                <div className="absolute top-4 left-4 bg-purple-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  Strategic Growth
                </div>
              </div>
              <div className="space-y-4">
                <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-handshake-line text-purple-600"></i>
                    </div>
                    <h5 className="font-semibold text-gray-900">Partnership Management</h5>
                  </div>
                  <p className="text-sm text-gray-600">Build and nurture strong, long-term relationships with sponsors and partners who align with your vision.</p>
                </div>
                
                <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-award-line text-blue-600"></i>
                    </div>
                    <h5 className="font-semibold text-gray-900">Sponsorship Acquisition</h5>
                  </div>
                  <p className="text-sm text-gray-600">Secure valuable sponsors that amplify your team's brand and expand your reach in the community.</p>
                </div>
                
                <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-line-chart-line text-green-600"></i>
                    </div>
                    <h5 className="font-semibold text-gray-900">Revenue Generation</h5>
                  </div>
                  <p className="text-sm text-gray-600">Leverage data-driven insights to create revenue streams and fuel long-term financial sustainability for your team.</p>
                </div>
              </div>
            </div>

            <div className="space-y-3">
              <div className="flex items-center justify-between p-3 bg-purple-50 rounded border-l-4 border-purple-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-building-line text-purple-600"></i>
                  <span className="font-medium text-gray-900">Corporate Partnerships</span>
                </div>
                <span className="text-sm text-purple-600">12 Active</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-blue-50 rounded border-l-4 border-blue-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-megaphone-line text-blue-600"></i>
                  <span className="font-medium text-gray-900">Brand Sponsorships</span>
                </div>
                <span className="text-sm text-blue-600">8 Secured</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-green-50 rounded border-l-4 border-green-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-money-dollar-circle-line text-green-600"></i>
                  <span className="font-medium text-gray-900">Revenue Tracking</span>
                </div>
                <span className="text-sm text-green-600">$125K Generated</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-orange-50 rounded border-l-4 border-orange-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-bar-chart-box-line text-orange-600"></i>
                  <span className="font-medium text-gray-900">Performance Analytics</span>
                </div>
                <span className="text-sm text-orange-600">Real-time Insights</span>
              </div>
            </div>

            <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg p-4 mt-6">
              <div className="flex items-center justify-between">
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1">Ready to Maximize Your Partnerships?</h5>
                  <p className="text-sm text-gray-600">Transform sponsorships into sustainable growth opportunities</p>
                </div>
                <button className="bg-purple-500 text-white px-6 py-2 rounded-lg hover:bg-purple-600 transition-colors whitespace-nowrap cursor-pointer">
                  Get Started
                </button>
              </div>
            </div>
          </div>
        );
      case 'store-management':
        return (
          <div className="bg-white rounded-lg p-6">
            <div className="text-center mb-6">
              <h4 className="text-2xl font-bold text-gray-900 mb-2">Team Store Management</h4>
              <p className="text-gray-600">Simplify Apparel Management and Keep Your Team Looking Great</p>
            </div>
            
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20baseball%20team%20uniform%20jersey%20with%20customizable%20name%20and%20number%2C%20clean%20white%20background%2C%20sports%20apparel%20product%20display%2C%20high%20quality%20team%20merchandise&width=200&height=200&seq=uniform-jersey&orientation=squarish"
                  alt="Team Jersey"
                  className="w-full h-32 object-cover object-top rounded mb-3"
                />
                <h5 className="font-semibold text-gray-900 mb-1">Team Jerseys</h5>
                <p className="text-sm text-gray-600 mb-2">Custom jerseys with player names</p>
                <div className="flex justify-between items-center">
                  <span className="font-bold text-orange-600">$45.99</span>
                  <button className="bg-orange-500 text-white px-3 py-1 rounded text-sm hover:bg-orange-600">
                    Order
                  </button>
                </div>
              </div>
              
              <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                <img 
                  src="https://readdy.ai/api/search-image?query=Baseball%20team%20cap%20hat%20with%20logo%20embroidery%2C%20professional%20sports%20team%20merchandise%2C%20clean%20white%20background%2C%20high%20quality%20team%20apparel&width=200&height=200&seq=team-cap&orientation=squarish"
                  alt="Team Cap"
                  className="w-full h-32 object-cover object-top rounded mb-3"
                />
                <h5 className="font-semibold text-gray-900 mb-1">Team Caps</h5>
                <p className="text-sm text-gray-600 mb-2">Embroidered team logo caps</p>
                <div className="flex justify-between items-center">
                  <span className="font-bold text-orange-600">$24.99</span>
                  <button className="bg-orange-500 text-white px-3 py-1 rounded text-sm hover:bg-orange-600">
                    Order
                  </button>
                </div>
              </div>
            </div>

            <div className="space-y-3">
              <div className="flex items-center justify-between p-3 bg-green-50 rounded border-l-4 border-green-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-check-circle-line text-green-600"></i>
                  <span className="font-medium text-gray-900">Streamlined Uniform Ordering</span>
                </div>
                <span className="text-sm text-green-600">Active</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-blue-50 rounded border-l-4 border-blue-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-user-settings-line text-blue-600"></i>
                  <span className="font-medium text-gray-900">Personalized Options</span>
                </div>
                <span className="text-sm text-blue-600">Available</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-orange-50 rounded border-l-4 border-orange-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-refresh-line text-orange-600"></i>
                  <span className="font-medium text-gray-900">Automated Reordering</span>
                </div>
                <span className="text-sm text-orange-600">Enabled</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-purple-50 rounded border-l-4 border-purple-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-bank-card-line text-purple-600"></i>
                  <span className="font-medium text-gray-900">Integrated Payments</span>
                </div>
                <span className="text-sm text-purple-600">Secure</span>
              </div>
            </div>
          </div>
        );
      case 'team-management':
        return (
          <div className="bg-white rounded-lg p-6">
            <div className="text-center mb-6">
              <h4 className="text-2xl font-bold text-gray-900 mb-2">Simplified Team Management: All-in-One Solution for Seamless Coordination</h4>
              <p className="text-gray-600">Streamline Your Team's Operations and Focus on Success. Efficient team management is at the heart of every successful team. CLUB7MS brings everything you need into one easy-to-use platform.</p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20sports%20team%20management%20dashboard%20interface%20showing%20player%20roster%20coordination%2C%20real-time%20statistics%20tracking%2C%20match%20scheduling%20system%2C%20modern%20mobile%20app%20design%20with%20clean%20layout%2C%20team%20coordination%20tools%20and%20live%20updates%20display&width=400&height=300&seq=team-management-dashboard&orientation=landscape"
                  alt="Team Management Dashboard"
                  className="w-full h-64 object-cover object-top rounded-lg shadow-lg"
                />
                <div className="absolute top-4 left-4 bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  All-in-One Platform
                </div>
              </div>
              <div className="space-y-4">
                <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-organization-chart text-blue-600"></i>
                    </div>
                    <h5 className="font-semibold text-gray-900">Effortless Coordination</h5>
                  </div>
                  <p className="text-sm text-gray-600">From onboarding to scheduling and roster management, simplify your team's day-to-day tasks.</p>
                </div>
                
                <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-notification-3-line text-green-600"></i>
                    </div>
                    <h5 className="font-semibold text-gray-900">Instant Selections &amp; Announcements</h5>
                  </div>
                  <p className="text-sm text-gray-600">Easily manage last-minute changes, player availability, and team updates.</p>
                </div>
                
                <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-bar-chart-2-line text-purple-600"></i>
                    </div>
                    <h5 className="font-semibold text-gray-900">Real-Time Stats &amp; Itineraries</h5>
                  </div>
                  <p className="text-sm text-gray-600">Stay on top of game schedules, player stats, and tournament details with real-time updates.</p>
                </div>
              </div>
            </div>

            <div className="space-y-3 mb-6">
              <div className="flex items-center justify-between p-3 bg-blue-50 rounded border-l-4 border-blue-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-user-settings-line text-blue-600"></i>
                  <span className="font-medium text-gray-900">Player Roster Management</span>
                </div>
                <span className="text-sm text-blue-600">24 Active Players</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-green-50 rounded border-l-4 border-green-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-calendar-check-line text-green-600"></i>
                  <span className="font-medium text-gray-900">Schedule Coordination</span>
                </div>
                <span className="text-sm text-green-600">15 Upcoming Events</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-purple-50 rounded border-l-4 border-purple-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-live-line text-purple-600"></i>
                  <span className="font-medium text-gray-900">Live Match Feeds</span>
                </div>
                <span className="text-sm text-purple-600">Real-time Updates</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-orange-50 rounded border-l-4 border-orange-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-notification-badge-line text-orange-600"></i>
                  <span className="font-medium text-gray-900">Instant Announcements</span>
                </div>
                <span className="text-sm text-orange-600">Push Notifications</span>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-4">
              <div className="flex items-center justify-between">
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1">Ready to Streamline Your Team Management?</h5>
                  <p className="text-sm text-gray-600">Keep everyone connected with live match updates through your custom app</p>
                </div>
                <button className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-colors whitespace-nowrap cursor-pointer">
                  Get Started
                </button>
              </div>
            </div>
          </div>
        );
      case 'communication-channels':
        return (
          <div className="bg-white rounded-lg p-6">
            <div className="text-center mb-6">
              <h4 className="text-2xl font-bold text-gray-900 mb-2">Boost Fan & Community Engagement</h4>
              <p className="text-gray-600">Stay Connected with Fans, Families, and Sponsors. Communication is key to keeping your team's community engaged and informed. With CLUB7MS, you can ensure every message reaches the right people, every time.</p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20sports%20team%20communication%20dashboard%20showing%20social%20media%20management%20interface%2C%20fan%20engagement%20notifications%2C%20community%20messaging%20system%2C%20modern%20mobile%20app%20design%20with%20clean%20layout%2C%20digital%20communication%20tools%20and%20social%20media%20integration%20display&width=400&height=300&seq=communication-dashboard&orientation=landscape"
                  alt="Communication Channels Dashboard"
                  className="w-full h-64 object-cover object-top rounded-lg shadow-lg"
                />
                <div className="absolute top-4 left-4 bg-green-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  Community Engagement
                </div>
              </div>
              <div className="space-y-4">
                <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-notification-3-line text-green-600"></i>
                    </div>
                    <h5 className="font-semibold text-gray-900">Effortless Notifications</h5>
                  </div>
                  <p className="text-sm text-gray-600">Send club-wide, team-specific, or group-focused notifications instantly, keeping everyone in the loop.</p>
                </div>
                
                <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-share-line text-blue-600"></i>
                    </div>
                    <h5 className="font-semibold text-gray-900">Enhanced Social Media Management</h5>
                  </div>
                  <p className="text-sm text-gray-600">Manage and track interactions across all your social channels, ensuring your digital presence is strong and consistent.</p>
                </div>
                
                <div className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-rocket-line text-purple-600"></i>
                    </div>
                    <h5 className="font-semibold text-gray-900">Unified Strategy</h5>
                  </div>
                  <p className="text-sm text-gray-600">Elevate your team's presence across all platforms with a streamlined approach that maximizes engagement and reach.</p>
                </div>
              </div>
            </div>

            <div className="space-y-3 mb-6">
              <div className="flex items-center justify-between p-3 bg-green-50 rounded border-l-4 border-green-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-message-3-line text-green-600"></i>
                  <span className="font-medium text-gray-900">Club-wide Notifications</span>
                </div>
                <span className="text-sm text-green-600">Instant Delivery</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-blue-50 rounded border-l-4 border-blue-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-group-line text-blue-600"></i>
                  <span className="font-medium text-gray-900">Team-specific Messaging</span>
                </div>
                <span className="text-sm text-blue-600">Targeted Communication</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-purple-50 rounded border-l-4 border-purple-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-hashtag text-purple-600"></i>
                  <span className="font-medium text-gray-900">Social Media Integration</span>
                </div>
                <span className="text-sm text-purple-600">Multi-platform Management</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-orange-50 rounded border-l-4 border-orange-500">
                <div className="flex items-center space-x-3">
                  <i className="ri-bar-chart-2-line text-orange-600"></i>
                  <span className="font-medium text-gray-900">Engagement Analytics</span>
                </div>
                <span className="text-sm text-orange-600">Performance Tracking</span>
              </div>
            </div>

            <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-lg p-4">
              <div className="flex items-center justify-between">
                <div>
                  <h5 className="font-semibold text-gray-900 mb-1">Ready to Boost Community Engagement?</h5>
                  <p className="text-sm text-gray-600">Connect with fans, families, and sponsors through unified communication channels</p>
                </div>
                <button className="bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600 transition-colors whitespace-nowrap cursor-pointer">
                  Get Started
                </button>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <section className="section-wrap bg-gray-900">
      <div className="max-w-7xl page-container">
        <div className="text-center section-heading-gap">
          <p className="text-orange-500 text-lg font-medium mb-2">Club7ms</p>
          <h2 className="text-4xl font-bold text-white mb-4">
            Your All-in-One Platform for Team Management, Engagement, and Growth
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Professional tools for every aspect of sports organization management
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6 lg:gap-12 items-start">
          {/* Left Side - Content with Tabs */}
          <div>
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">
                A NEXT-GENERATION <span className="text-orange-500">GRASSROOTS SPORTS TEAM MANAGEMENT</span> SOLUTION
              </h3>
              <p className="text-gray-300 mb-6">
                At Club7MS, we believe every grassroots team deserves professional-grade management.
                From the first signup to the final scoreboard, we make every moment organized, connected, and inspiring.
              </p>
              
              {/* Navigation Tabs */}
              <div className="flex flex-wrap gap-2 mb-6">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                      activeTab === tab.id
                        ? 'bg-orange-500 text-white'
                        : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                    }`}
                  >
                    <i className={`${tab.icon} mr-2`}></i>
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-white mb-2">Branded for Impact</h4>
                  <p className="text-gray-300">Customize your app with your team's colors, logo, and design to create a unique and memorable brand experience</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-white mb-2">Seamless User Experience</h4>
                  <p className="text-gray-300">Simplify communication for players, families, fans, and sponsors with a sleek, easy-to-navigate interface</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-white mb-2">Legacy in the Making</h4>
                  <p className="text-gray-300">Build a lasting impression with an app that fosters community, enhances engagement, and strengthens long-term loyalty</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-white mb-2">Complete Platform Integration</h4>
                  <p className="text-gray-300">Seamlessly connect all aspects of team management in one comprehensive branded solution</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Interactive Content */}
          <div className="lg:sticky lg:top-8">
            {renderTabContent()}
            
            {/* Stats Overlay */}
            <div className="mt-6 grid grid-cols-2 gap-4">
              <div className="bg-gray-800 rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-orange-500">50+</div>
                <div className="text-sm text-gray-300">Teams Managed</div>
              </div>
              <div className="bg-gray-800 rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-orange-500">200+</div>
                <div className="text-sm text-gray-300">Events Scheduled</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClubManagementSection;
